import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import Paper from "@mui/material/Paper";
import Stack from "@mui/material/Stack";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import React, { useState } from "react";

const DriverForm = () => {
  const [role, setRole] = useState("");

  const handleChange = (event) => {
    setRole(event.target.value);
  };
  return (
    <Stack direction='column' spacing={2}>
      <Box component={Paper} elevation={0}>
        <Box px={3} py={2}>
          <Typography variant='h4'>Driver Information</Typography>
        </Box>
        <Divider />
        <Stack direction='column' spacing={2} px={3} py={2}>
          <TextField fullWidth label='First Name' id='first_name' />
          <TextField fullWidth label='Last Name' id='last_name' />
          <TextField fullWidth label='Email' id='email' />
          <TextField fullWidth label='Mobile Number' id='mobile_number' />
          <TextField fullWidth label='Address' id='address' />
          <TextField fullWidth label='Password' id='password' />
        </Stack>
      </Box>

      {/* <TextField fullWidth label="First Name" id="first_name" />
      <TextField fullWidth label="Last Name" id="last_name" />
      <TextField fullWidth label="Email" id="email" />
      <TextField fullWidth label="Mobile Number" id="mobile_number" />
      <TextField fullWidth label="Address" id="address" />
      <TextField fullWidth label="Password" id="password" /> */}

      <Box component={Paper} elevation={0}>
        <Box px={3} py={2}>
          <Typography variant='h4'>Registration Card</Typography>
        </Box>
        <Divider />
        <Box px={3} py={2}>
          <TextField
            sx={{ width: { xs: "100%", sm: "50%" } }}
            label='Registration Number'
            id='registration_number'
          />
          <Button
            sx={{
              display: "block",
              marginTop: "8px",
              bgcolor: "#0062cc",
              color: "white",
            }}
            variant='contained'
          >
            Choose File
          </Button>
        </Box>
      </Box>

      <Box component={Paper} elevation={0}>
        <Box px={3} py={2}>
          <Typography variant='h4'>Driver License</Typography>
        </Box>
        <Divider />
        <Box px={3} py={2}>
          <TextField
            sx={{ width: { xs: "100%", sm: "50%" } }}
            label='License Number'
            id='license_number'
          />
          <Button
            sx={{
              display: "block",
              marginTop: "8px",
              bgcolor: "#0062cc",
              color: "white",
            }}
            variant='contained'
          >
            Choose File
          </Button>
        </Box>
      </Box>

      <Stack direction='row' spacing={2}>
        <Button variant='contained' sx={{ padding: 1 }} disabled>
          SAVE
        </Button>
        <Button variant='contained' sx={{ padding: 1 }} color='error'>
          CANCEL
        </Button>
      </Stack>
    </Stack>
  );
};

export default DriverForm;
